/**
 * Yandex Maps v3 scheme customization — the clean, light "operator" map style
 * (clutter hidden, custom water/building/road/park colors). Kept as an untyped
 * data blob the widget passes opaquely to `YMapDefaultSchemeLayer`.
 */
export const MAP_CUSTOMIZATION = [
  {
    types: ['point', 'polyline', 'polygon'],
    tags: {
      any: [
        'urban_area',
        'poi',
        'path',
        'district',
        'traffic_light',
        'crosswalk',
        'transit_schema',
        'transit_line',
        'geographic_line',
        'terrain',
      ],
    },
    stylers: { visibility: 'off' },
  },
  {
    types: ['point', 'polyline', 'polygon'],
    tags: { any: ['water'] },
    stylers: { color: 'DEE8F4' },
  },
  {
    types: ['point', 'polyline', 'polygon'],
    elements: ['label.text.fill'],
    tags: { any: ['transit_location'] },
    stylers: { color: '000000', scale: 0.75 },
  },
  {
    types: ['point', 'polyline', 'polygon'],
    tags: { any: ['building'] },
    stylers: { color: 'F2F1E7' },
  },
  {
    types: ['point'],
    elements: ['label.icon', 'label.text.fill'],
    tags: { any: ['entrance'] },
    stylers: { color: 'aba796', scale: 1.1 },
  },
  {
    types: ['point'],
    elements: ['label.text.outline'],
    tags: { any: ['entrance'] },
    stylers: { color: 'ffffff', scale: 1.1 },
  },
  {
    types: ['point', 'polyline', 'polygon'],
    elements: ['label.icon'],
    tags: { any: ['transit_location'] },
    stylers: { scale: 0.8 },
  },
  {
    types: ['point', 'polyline', 'polygon'],
    tags: { any: ['park', 'national_park', 'landcover', 'cemetery'] },
    stylers: { color: 'E9F2E4' },
  },
  {
    types: ['polygon'],
    tags: {
      any: [
        'land',
        'residential',
        'industrial',
        'medical',
        'sports_ground',
        'beach',
        'construction_site',
        'parking',
        'terrain',
      ],
    },
    stylers: { color: 'F9F7F3' },
  },
  {
    types: ['polyline'],
    elements: ['geometry.fill'],
    tags: { any: ['road_1', 'road_2', 'road_3', 'road_4', 'road_5', 'road_6', 'road_7'] },
    stylers: { color: 'ffffff' },
  },
  {
    types: ['polyline'],
    elements: ['label'],
    tags: { any: ['road_1', 'road_2', 'road_3', 'road_4', 'road_5', 'road_6', 'road_7'] },
    stylers: { scale: 0.7 },
  },
  {
    types: ['polyline'],
    elements: ['geometry.outline'],
    tags: { any: ['road_1', 'road_2', 'road_3', 'road_4', 'road_5', 'road_6', 'road_7'] },
    stylers: { color: 'EBE8DC' },
  },
];
